import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux'
import { Button } from 'reactstrap';
import { Redirect, Link } from "react-router-dom";
import PostcategoryForm from '../PostcategoryForm/PostcategoryForm';
import PageTitle from '../../../components/PageTitle/PageTitle';

import { startCreatePostcategory, createPostcategory } from '../../../redux/modules/post_categories';

const PostcategoryCreate = () => {
    const { t }    = useTranslation();
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(startCreatePostcategory());
    }, [dispatch])

    const submit = (values) => {
        dispatch(createPostcategory(values));
    }

    const { post_categorySuccessfullyCreated } = useSelector(state => state.post_categories);

    let title = <span>{t('post_categories.add')}</span>;

    const actions =
        <Button tag={Link} to="/post_categories" color="warning" size="sm">
            <i className="fa fa-arrow-left"></i>&nbsp;{ t('common.back')}
        </Button>

    return (
        <div className="PostcategoryCreate">
            <PageTitle icon="th" title={ title } actions={ actions } />

            {post_categorySuccessfullyCreated &&
                <Redirect to="/post_categories"/>
            }

            <PostcategoryForm onSubmit={ submit } isCreation="true" />
        </div>
    );
}

export default PostcategoryCreate
